export default {"src":"/_next/static/media/add-circle.a4324bbc.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};